import { Map } from "immutable";

import {
  WorkScheduleMapper,
  WorkScheduleDefinitionMapper,
} from "features/planner/planner.mappers";

import { ACTIONS } from "features/planner/employee/employee.constants";

const initialState = Map({
  byCardId: Map(),
  definitions: Map(),
});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_EMPLOYEE_WORK_SCHEDULES:
    case ACTIONS.QUERY_EMPLOYEE_WORK_SCHEDULES: {
      if (error) return state;

      const { employeeCardId } = action;

      return state.setIn(
        ["byCardId", employeeCardId.toString()],
        Map(
          payload.map(WorkSchedule => [
            WorkSchedule.workScheduleId.toString(),
            WorkScheduleMapper.from(WorkSchedule),
          ]),
        ),
      );
    }

    case ACTIONS.GET_WORK_SCHEDULE_DEFINITIONS: {
      return state.set(
        "definitions",
        Map(
          payload.map(workScheduleDefinition => [
            workScheduleDefinition.workScheduleDefinitionId.toString(),
            WorkScheduleDefinitionMapper.from(workScheduleDefinition),
          ]),
        ),
      );
    }

    case ACTIONS.DELETE_EMPLOYEE_WORK_SCHEDULE: {
      if (action.error) return state;

      return state.deleteIn([
        "byCardId",
        action.cardId.toString(),
        action.workScheduleId.toString(),
      ]);
    }

    case ACTIONS.UPDATE_EMPLOYEE_WORK_SCHEDULE:
    case ACTIONS.CREATE_EMPLOYEE_WORK_SCHEDULE: {
      if (action.error) return state;

      return state.setIn(
        [
          "byCardId",
          action.cardId.toString(),
          payload.workScheduleId.toString(),
        ],
        WorkScheduleMapper.from(payload),
      );
    }

    default:
      return state;
  }
};
